import * as React from 'react';
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import * as mapbox from 'mapbox-gl';
import { usePopup } from '../../hooks/usePopup';
import { showIf } from '../../helpers';

export interface PopupProps {
    marker: mapbox.Marker;
    title: string;
    subtitle: string;
    href: string;
    markerSize: number;
}

export const Popup: React.FunctionComponent<PopupProps> = ({ marker, title, subtitle, href, markerSize }) => {
    const container = useRef(document.createElement('div'));
    const popup = usePopup(container.current, markerSize);

    if (popup) {
        marker.setPopup(popup);
    }

    return showIf(container.current, () => createPortal((
        <>
            <h3>{title}</h3>
            <h4>{subtitle}</h4>

            <a href={href} className="button">
                View
            </a>
        </>
    ), container.current));
};

Popup.displayName = 'Popup';
